import './event-image-modal.scss';
import { createPortal } from 'react-dom';
import PdfPreview from '../pdf-preview/pdf-preview';
import { isPdf } from '../../helpers/eventHelpers';
import { isMobileSafari } from '../../utils/browserUtils';

type SelectedImage = {
  images: string[];
  alt: string;
  index: number;
};

type EventImageModalProps = {
  selectedImage: SelectedImage;
  onClose: () => void;
  onChangeIndex: (direction: -1 | 1) => void;
};

const EventImageModal = ({ selectedImage, onClose, onChangeIndex }: EventImageModalProps) => {
  const { images, alt, index } = selectedImage;
  const file = images[index];

  return createPortal(
    <div className="event-modal" role="dialog" aria-modal="true" aria-label="Expanded event image" onClick={onClose}>
      <div className="event-modal__content" onClick={(event) => event.stopPropagation()}>
        <button type="button" className="event-modal__close" onClick={onClose} aria-label="Close image viewer">
          ×
        </button>
        {images.length > 1 && (
          <>
            <ModalNavigationButton direction="previous" onClick={() => onChangeIndex(-1)} />
            <ModalNavigationButton direction="next" onClick={() => onChangeIndex(1)} />
            <span className="event-modal__count" aria-live="polite">
              {index + 1} / {images.length}
            </span>
          </>
        )}
        {isPdf(file) ? (
          isMobileSafari() ? (
            <iframe className="event-modal__pdf" src={file} title={`PDF preview: ${alt}`} />
          ) : (
            <PdfPreview file={file} className="pdf-preview--modal" />
          )
        ) : (
          <img className="event-modal__image" src={file} alt={alt} />
        )}
      </div>
    </div>,
    document.body
  );
};

const ModalNavigationButton = ({
  direction,
  onClick,
}: {
  direction: 'previous' | 'next';
  onClick: () => void;
}) => (
  <button
    type="button"
    className={`event-modal__nav event-modal__nav--${direction}`}
    onClick={onClick}
    aria-label={`${direction === 'previous' ? 'Previous' : 'Next'} event image`}
  >
    <svg className="event-image-arrow" viewBox="0 0 24 24" aria-hidden="true">
      <path
        d={direction === 'previous' ? 'M14.5 5.5L8 12l6.5 6.5' : 'M9.5 5.5L16 12l-6.5 6.5'}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </button>
);

export default EventImageModal;
